import React from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

const ORDER = ["light", "dark", "system"];
const LABEL = { light: "Light", dark: "Dark", system: "Auto" };
const ICON = { light: Sun, dark: Moon, system: Monitor };

export const ThemeToggle = ({ compact = false }) => {
  const { theme, setTheme } = useTheme();
  const Icon = ICON[theme] || Sun;
  const next = () => {
    const i = ORDER.indexOf(theme);
    setTheme(ORDER[(i + 1) % ORDER.length]);
  };
  return (
    <button
      type="button"
      onClick={next}
      title={`Theme: ${LABEL[theme]} (click to cycle)`}
      data-testid="theme-toggle"
      className={
        compact
          ? "w-9 h-9 grid place-items-center rounded-md border border-[color:var(--border-default)] text-[color:var(--fg-secondary)] hover:text-[color:var(--fg-primary)] hover:bg-[color:var(--bg-inset)] transition-colors"
          : "inline-flex items-center gap-1.5 h-9 px-2.5 rounded-md border border-[color:var(--border-default)] text-[13px] text-[color:var(--fg-secondary)] hover:text-[color:var(--fg-primary)] hover:bg-[color:var(--bg-inset)] transition-colors"
      }
    >
      <Icon size={16} />
      {!compact && <span className="hidden lg:inline">{LABEL[theme]}</span>}
    </button>
  );
};

export const ThemeSegmented = () => {
  const { theme, setTheme } = useTheme();
  return (
    <div className="inline-flex rounded-md border border-[color:var(--border-default)] p-0.5" data-testid="theme-segmented">
      {ORDER.map((k) => {
        const I = ICON[k];
        const active = theme === k;
        return (
          <button
            key={k}
            onClick={() => setTheme(k)}
            data-testid={`theme-${k}`}
            title={LABEL[k]}
            className={
              "w-8 h-7 grid place-items-center rounded-sm text-[13px] " +
              (active
                ? "bg-[color:var(--bg-inset)] text-[color:var(--fg-primary)]"
                : "text-[color:var(--fg-muted)] hover:text-[color:var(--fg-primary)]")
            }
          >
            <I size={14} />
          </button>
        );
      })}
    </div>
  );
};
